// extracted by mini-css-extract-plugin
export default {"tabs_container":"TabsNew_tabs_container__BaBkp","tab":"TabsNew_tab__mkyHd"};